export default function importDocumentDirective() {
  return {
    restrict: 'E',
    template: require('./import-document.html'),
    scope: {
      customerId: '@',
      importTypeId: '@',
      title: '@',
      toolTip: '@',
      tooltipAppendToSelector: '@',
      entityId: '@',
      mimeType: '@',
      fileName: '@',
      iconClass: '@',
      refreshCallBack: '&',
      showButton: '@',
      buttonTitle: '@',
      buttonClass: '@',
    },
    controller: 'ImportDocumentDirectiveController',
    controllerAs: 'importDocumentVM',
    bindToController: true,
    replace: true,
  };
}
